import h from "trader-hyperscript";
import * as style from "../../../styles/style.css.classes";
import * as routes from "../../routes";
import * as joda from "@js-joda/core";
import { parseWeekday } from "../../parsing_from_ur";
import {
  HHmm,
  renderEnrollmentStatus,
  renderFirstNameLastName,
  wrapInParenthesesIfNotEmpty,
} from "../../render";
import { renderPeriod, translateWeekday } from "../../translations_specific";
import {
  enrollment_status,
  enrollmentid,
  lessongroupid,
  periodid,
  studentid,
  weekday,
} from "../../../sql/classy/types";
import { Source } from "trader.ts/types/source";
import { Remote } from "trader.ts";
import { rpcIntoRemote } from "trader.ts/network.remote";
import { renderRemote } from "trader.ts/ui.common";

export type studentsearchitem = {
  id: studentid;
  firstname: string;
  lastname: string;
  email: string | null;
  enrollments:
    | {
        enrollmentid: enrollmentid;
        enrollmentstatus: enrollment_status;
        lessongroupid: lessongroupid;
        weekday: weekday;
        time: joda.LocalTime;
        lastlesson: joda.LocalDate | null;
        startedlessonson: joda.LocalDate;
        stoppedlessonson: joda.LocalDate | null;
        period_id: periodid;
        period_firstday: joda.LocalDate;
        period_lastday: joda.LocalDate;
        teacher_firstname: string;
        teacher_lastname: string;
      }[]
    | null;
};

export function render(opts: {}): HTMLElement | HTMLElement[] {
  const studentsRS: Source<Remote.Remote<studentsearchitem[]>> = new Source({
    tag: "initial",
  });
  void rpcIntoRemote(
    routes.getAllStudentsSpec,
    undefined,
    { searchstring: "" },
    studentsRS,
  );

  const today = joda.LocalDate.now();

  return renderRemote(studentsRS, (students) => {
    return students.length === 0 ? (
      <a href={routes.studentnewRoute.link()}>
        {"Maak je eerste student aan!"}
      </a>
    ) : (
      <table>
        {renderStudentListHeader()}
        {students.map((stu) => renderStudentListItem(today, stu, null))}
      </table>
    );
  });
}

export function renderStudentListHeader() {
  return (
    <tr>
      <th>{"student"}</th>
      <th className={style.remove_on_phone}>{"inschrijvingen"}</th>
    </tr>
  );
}

export function renderStudentListItem(
  today: joda.LocalDate,
  student: studentsearchitem,
  searchstring: string | null,
) {
  return (
    <tr>
      <td>
        <div>
          <a href={routes.studentOverviewRoute.link({ studentid: student.id })}>
            <b>{renderFirstNameLastName(student)}</b>
          </a>
        </div>
        {searchstring === null ? (
          []
        ) : (student.email || "")
            .toLowerCase()
            .startsWith(searchstring.toLowerCase()) ? (
          <div>{student.email || ""}</div>
        ) : (
          []
        )}
      </td>
      <td className={style.remove_on_phone}>
        {(student.enrollments || []).map((enr) => {
          const period = renderPeriod(enr.period_firstday, enr.period_lastday);
          const wd = translateWeekday(parseWeekday(enr.weekday));
          const time = enr.time.format(HHmm);
          const teach = renderFirstNameLastName({
            firstname: enr.teacher_firstname,
            lastname: enr.teacher_lastname,
          });
          const status = wrapInParenthesesIfNotEmpty(
            renderEnrollmentStatus(enr.enrollmentstatus, {
              ...enr,
              lessons: { tag: "dont_show_last_lesson" },
            }),
          );
          const label = `${period}: ${wd} - ${time} - ${teach} ${status}`;
          return (
            <div>
              <a
                style={
                  enr.lastlesson && enr.lastlesson.isAfter(today)
                    ? ""
                    : "color: gray;opacity: 0.7; display: block"
                }
                href={routes.lessongroup_generalRoute.link({
                  lessongroupid: enr.lessongroupid,
                })}
              >
                {label}
              </a>
            </div>
          );
        })}
      </td>
    </tr>
  );
}
